import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApplyCvData } from '../../core/cv1g/lya-cv.types';

@Injectable({
  providedIn: 'root',
})
export class SharedCvDataService {
  constructor(private http: HttpClient) {}
  getApplyData(companyId: string, key: string): Observable<ApplyCvData> {
    return this.http.get<ApplyCvData>(`lya/p-candidates/apply/cv-data/${key}`, {
      headers: { company_id: companyId },
    });
  }
}
